import React, { useState, useEffect } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "./Awards.css";

import awardimg1 from "../assets/award-img1.jpg";
import awardimg2 from "../assets/award-img2.jpg";
import awardimg3 from "../assets/award-img3.jpg";
import awardimg4 from "../assets/award-img4.jpg";
import awardimg5 from "../assets/award-img5.jpg";
import awardimg6 from "../assets/award-img6.png";
import awardimg7 from "../assets/award-img7.jpg";
import awardimg8 from "../assets/award-img8.jpg";
import awardimg9 from "../assets/award-img9.png";
import awardimg10 from "../assets/award-img10.png";
import awardimg11 from "../assets/award-img11.jpg";
import awardimg12 from "../assets/award-img12.jpg";
import awardimg13 from "../assets/award-img13.jpg";
import awardimg14 from "../assets/award-img14.JPG";
import awardimg15 from "../assets/award-img15.jpg";

import extaward1 from "../assets/ESG & Safety Excellence Award - ACMA.png";
import extaward2 from "../assets/Prithvi Award - ESG research foundation, New Delhi.jpg";
import extaward3 from "../assets/Silver Award - CII EHS Excellence Awards.JPG";
import extaward4 from "../assets/Silver Award - India Green Manufacturing Challenge.jpg";
import extaward5 from "../assets/STAR Award for ESG practices - Tamil Nadu govt.jpg";
import extaward6 from "../assets/IGBC Green Building – Platinum Rating Award.jpg";
import extaward7 from "../assets/Silver certificate of merit for manufacturing & supply chain excellence - Frost & Sullivan.jpg";
import extaward8 from "../assets/Gold Award - The Economic times India Manufacturing Excellence Award.jpg";
import extaward9 from "../assets/Platinum award - Auto ancillary sector – Medium category - The Economic Times India Manufacturing Excellence Awards.jpg";
import extaward10 from "../assets/Best Foundry Award in large scale category - ALUCAST.jpg";
import extaward11 from "../assets/Certificate of Merit – Striving - ACMA Excellence Awards.png";

// NEW: 2026 external awards
import extaward12 from "../assets/2026 - Most Innovative 5G use case award - Hon’ble Union Minister of Communications at India Mobile Congress.jpg";
import extaward13 from "../assets/2026 - Prithvi Award – ESG Research Foundation, Global ESG Conference.jpg";


import Footer from "./Footer";

const allLogos = {
  "Customer Awards": [
    {
      img: awardimg1,
      alt: "Awards",
      year: 2026,
      caption: "2026 - Q-Prime Gold Award - DICV",
    },
    {
      img: awardimg2,
      alt: "Awards",
      year: 2026,
      caption: "2026 - Supplier of the Year – Quality Award - Hyundai",
    },
    {
      img: awardimg3,
      alt: "Awards",
      year: 2025,
      caption: "2025 - Quality Excellence Award - Kia",
    },
    {
      img: awardimg4,
      alt: "Awards",
      year: 2025,
      caption:
        "2025 - Best Safety Practices Award - Direct sourcing - Cummins India",
    },
    {
      img: awardimg5,
      alt: "Awards",
      year: 2025,
      caption: "2025 - Best Cost Management Program Award - Paccar",
    },
    {
      img: awardimg6,
      alt: "Awards",
      year: 2024,
      caption: "2024 - Long term Supplier Award - Paccar",
    },
    {
      img: awardimg7,
      alt: "Awards",
      year: 2024,
      caption: "2024 - SPM Leader Award - Paccar",
    },
    {
      img: awardimg8,
      alt: "Awards",
      year: 2023,
      caption: "2023 - SPM Leader Award - DAF",
    },
    {
      img: awardimg9,
      alt: "Awards",
      year: 2023,
      caption: "2023 - Best performance award for ESG - Hyundai",
    },
    {
      img: awardimg10,
      alt: "Awards",
      year: 2023,
      caption:
        "2023 - Award for Panther 2.0 L engine launch Quality and Flow - Ford",
    },
    {
      img: awardimg11,
      alt: "Awards",
      year: 2023,
      caption:
        "2023 - Award for outstanding contribution in cost & capacity excellence - VECV",
    },
    {
      img: awardimg12,
      alt: "Awards",
      year: 2022,
      caption:
        "2022 - Customer support Excellence Award – Direct sourcing - Cummins India",
    },
    {
      img: awardimg13,
      alt: "Awards",
      year: 2022,
      caption: "2022 - Best Quality Consistent Supplier Award - Hanon",
    },
    {
      img: awardimg14,
      alt: "Awards",
      year: 2019,
      caption: "2019 - Supplier of the year Award - Paccar",
    },
    {
      img: awardimg15,
      alt: "Awards",
      year: 2019,
      caption: "2019 - Energy conservation 2019 – Gold Award - Hanon",
    },
  ],

  "External Awards": [
    // NEW: 2026 awards added at the top
    {
      img: extaward12,
      alt: "Awards",
      year: 2026,
      caption:
        "2026 - Most Innovative 5G use case award - Hon’ble Union Minister of Communications at India Mobile Congress",
    },
    {
      img: extaward13,
      alt: "Awards",
      year: 2026,
      caption:
        "2026 - Prithvi Award – ESG Research Foundation, Global ESG Conference",
    },
    {
      img: extaward6,
      alt: "Awards",
      year: 2026,
      caption: "2026 - IGBC Green Building – Platinum Rating Award",
    },

    {
      img: extaward1,
      alt: "Awards",
      year: 2025,
      caption: "2025 - ESG & Safety Excellence Award – ACMA",
    },
    {
      img: extaward2,
      alt: "Awards",
      year: 2025,
      caption:
        "2025 - Prithvi Award – ESG Research Foundation, New Delhi",
    },
    {
      img: extaward3,
      alt: "Awards",
      year: 2025,
      caption: "2025 - Silver Award – CII EHS Excellence Awards",
    },
    {
      img: extaward4,
      alt: "Awards",
      year: 2025,
      caption:
        "2025 - Silver Award – India Green Manufacturing Challenge",
    },
    {
      img: extaward5,
      alt: "Awards",
      year: 2025,
      caption: "2025 - STAR Award for ESG Practices – Tamil Nadu Govt",
    },
    {
      img: extaward11,
      alt: "Awards",
      year: 2024,
      caption:
        "2024 - Certificate of Merit – Striving – ACMA Excellence Awards",
    },
    {
      img: extaward10,
      alt: "Awards",
      year: 2022,
      caption:
        "2022 - Best Foundry Award in large scale category – ALUCAST",
    },
    {
      img: extaward9,
      alt: "Awards",
      year: 2011,
      caption:
        "2011 - Platinum Award - Auto ancillary sector – Medium category - The Economic Times India Manufacturing Excellence Awards",
    },
    {
      img: extaward7,
      alt: "Awards",
      year: 2010,
      caption:
        "2010 - Silver certificate of merit for manufacturing & supply chain excellence – Frost & Sullivan",
    },
    {
      img: extaward8,
      alt: "Awards",
      year: 2010,
      caption:
        "2010 - Gold Award – The Economic times India Manufacturing Excellence Award",
    },
  ],
};

const MAX_VISIBLE = 15;

export default function Awards() {
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState("Customer Awards");

  useEffect(() => {
    const tab = searchParams.get("tab");
    if (tab === "external") {
      setActiveTab("External Awards");
    } else if (tab === "customer") {
      setActiveTab("Customer Awards");
    }
  }, [searchParams]);

  const sorted = allLogos[activeTab];
  const visible = sorted.slice(0, MAX_VISIBLE);

  const hasArchive = activeTab === "Customer Awards";

  return (
    <section id="awards">
      <div className="customers-section-a">
        <h2>Awards & Recognition</h2>

        <div className="cust-underline-a"></div>

        <div className="tab-buttons-a">
          {Object.keys(allLogos).map((tab) => (
            <button
              key={tab}
              className={activeTab === tab ? "active" : ""}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="logo-grid-a">
          {visible.map((logo, index) => (
            <div className="logo-card-a" key={index}>
              <div className="award-img-box">
                <img src={logo.img} alt={logo.alt} />
              </div>

              {logo.caption && (
                <p className="award-caption">{logo.caption}</p>
              )}
            </div>
          ))}
        </div>

        {hasArchive && (
          <div className="award-archive-link-wrap">
            <Link
              to="/awards/archive"
              className="award-archive-link"
            >
              View Photo Archive ↗
            </Link>
          </div>
        )}
      </div>

      <Footer />
    </section>
  );
}
